import { useNavigate } from 'react-router-dom'
import { NoSymbolIcon } from '@heroicons/react/24/outline'
import { usePermissions } from '../hooks/usePermissions'
import { useProductAvailability } from '../hooks/useProductAvailability'
import { PERMISSIONS } from '../lib/permissions'
import { isSoldOutAnywhere } from '../lib/availability'

/**
 * Entry to the Availability page (register + kitchen display headers) with the number of
 * products out in any channel. Renders nothing without product.availability.
 */
const SoldOutButton = () => {
  const navigate = useNavigate()
  const { hasPermission } = usePermissions()
  const allowed = hasPermission(PERMISSIONS.PRODUCT_AVAILABILITY)
  const { products } = useProductAvailability(!allowed)

  if (!allowed) return null
  const count = products.filter(isSoldOutAnywhere).length

  return (
    <button
      type="button"
      onClick={() => navigate('/availability')}
      className="flex h-11 items-center gap-2 rounded-lg border border-brand-jasper bg-white px-4 text-sm font-semibold text-brand-jasper hover:bg-red-50"
    >
      <NoSymbolIcon className="h-5 w-5" />
      Sold out
      {count > 0 && (
        <span className="inline-flex min-w-[1.5rem] items-center justify-center rounded-full bg-brand-jasper px-2 py-0.5 text-xs font-bold text-white">
          {count}
        </span>
      )}
    </button>
  )
}

export default SoldOutButton
